/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * User role enumeration.
 */
export type UserRole = typeof UserRole[keyof typeof UserRole];


export const UserRole = {
  superadmin: 'superadmin',
  admin: 'admin',
  editor: 'editor',
  publisher: 'publisher',
  user: 'user',
} as const;
